import React from "react";
import LegalDocument from "../../components/legal/LegalDocument";
import { useCurrency } from "../../context/CurrencyContext";

export default function DataDeletion() {
  const { settings } = useCurrency();
  return (
    <LegalDocument
      eyebrow="Legal"
      title="Account & Data Deletion"
      text={settings?.legal_data_deletion}
      loading={!settings?.legal_data_deletion}
      relatedLinks={[
        { to: "/legal/privacy", label: "Privacy Policy" },
        { to: "/legal/terms/renter", label: "Renter Terms & Conditions" },
      ]}
    />
  );
}
